import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const SubscriptionSettingsPanel = lazy(() =>
  import('@repo/ui/features/settings/subscription-settings-panel').then((mod) => ({
    default: mod.SubscriptionSettingsPanel,
  })),
);

export default function SubscriptionSettingsPage() {
  return (
    <div className="w-full py-6">
      <Suspense fallback={<DendromapLoader message="Chargement des paramètres d'abonnement..." />}>
        <SubscriptionSettingsPanel />
      </Suspense>
    </div>
  );
}
